/**
 * api接口登录
 */
import { post } from '@/utils/http'

// 会话列表
export const apiChatSession = p => post('/chat/getChatSession.do', p)
// 消息
export const apiChatMessage = p => post('/chat/getChatMessage.do', p)
// 群
export const apiChatRoom = p => post('/chat/chatRoom.do', p)
export const apiGetChatRoom = p => post('/chat/getChatRoom.do', p)
// 会话打开
export const apiChatSessionOpen = p => post('/chat/chatSessionOpen.do', p)
export const apiChatRoomOpen = p => post('/chat/chatRoomOpen.do', p)
// 会话关闭
export const apiChatSessionDisplay = p => post('/chat/chatSessionDisplay.do', p)


// 登出
export const apiSignOutAdmin = p => post('/admin/signOutAdmin.do', p)
// 发送注册短信
export const apiSend = p => post('/user/send.do', p)
// 信息
export const apiUserId = p => post('/user/getUserId.do', p)
